// Khởi tạo sớm bằng tryInit thay vì đợi window load
(function initBgSlides(){
    if ($('#MS__wrapper.iframe').length) return; // bỏ qua khi embed iframe

    const maxTries = 150; // ~2.4s tối đa (150 * 16ms)
    let tries = 0;
    let autoSlideInterval;
    let currentIndex = 0;

    function raf(fn){ (window.requestAnimationFrame || function(cb){return setTimeout(cb,16);} )(fn); }

    function tryInit(){
        const $wrapper = $('#nth-ld-25-ld-bg');
        if(!$wrapper.length) return schedule();
        const $links = $wrapper.find('.list-navs a');
        const $slides = $wrapper.find('.bg');
        if(!$links.length || !$slides.length) return schedule();
        const mainSwiperEl = $('.main-swiper')[0];
        const mainSwiper = mainSwiperEl && mainSwiperEl.swiper;
        if(!mainSwiper) return schedule();

        function showSlide(i){
            $links.removeClass('active');
            $slides.removeClass('active');
            $links.eq(i).addClass('active');
            $slides.eq(i).addClass('active');
        }

        // Smooth scale feedback on change
        const raw = $wrapper[0];
        const TRANSITION_SPEED = 200; // ms
        if (raw) {
            raw.style.transition = `transform ${TRANSITION_SPEED}ms ease`;
            raw.style.willChange = 'transform';
        }
        function bumpScale(){
            if (!raw) return;
            requestAnimationFrame(() => { raw.style.transform = 'scale(1.02)'; });
            setTimeout(() => { raw.style.transform = 'scale(1)'; }, TRANSITION_SPEED);
        }

        function startAuto(){
            stopAuto();
            autoSlideInterval = setInterval(function(){
                if (mainSwiper.activeIndex === 3) {
                    currentIndex = (currentIndex + 1) % $slides.length;
                    showSlide(currentIndex);
                }
            }, 3000);
        }
        function stopAuto(){ if (autoSlideInterval) clearInterval(autoSlideInterval); }

        $links.off('click.__bg').on('click.__bg', function(e){
            e.preventDefault();
            stopAuto();
            if (mainSwiper.activeIndex === 3) {
                currentIndex = $(this).index();
                bumpScale();
                showSlide(currentIndex);
            }
            startAuto();
        });

        // Wheel desktop - one gesture = one move, normalized and smoothed
        if(!isMobileDevice()){
            const LINE_HEIGHT = 16;
            const MIN_ABS = 30;
            const WHEEL_LOCK = 600; // ms
            let lockUntil = 0;
            function normalizeDelta(e){
                let dx = e.deltaX, dy = e.deltaY;
                if (e.deltaMode === 1) { dx *= LINE_HEIGHT; dy *= LINE_HEIGHT; }
                else if (e.deltaMode === 2) { dx *= window.innerWidth; dy *= window.innerHeight; }
                return { dx, dy };
            }
            raw.addEventListener('wheel', function(e){
                if (mainSwiper.activeIndex !== 3) return;
                const { dx, dy } = normalizeDelta(e);
                if (Math.abs(dy) < Math.abs(dx)) return; // vertical only
                if (Math.abs(dy) < MIN_ABS) return;      // ignore tiny
                const now = Date.now();
                if (now < lockUntil) { e.preventDefault(); e.stopPropagation(); return; }
                const atLast = currentIndex === $slides.length - 1;
                const atFirst = currentIndex === 0;
                if (dy > 0) {
                    if(!atLast){
                        currentIndex++;
                        bumpScale();
                        showSlide(currentIndex);
                        lockUntil = now + WHEEL_LOCK;
                        e.preventDefault(); e.stopPropagation();
                        stopAuto(); startAuto();
                        return;
                    }
                } else {
                    if(!atFirst){
                        currentIndex--;
                        bumpScale();
                        showSlide(currentIndex);
                        lockUntil = now + WHEEL_LOCK;
                        e.preventDefault(); e.stopPropagation();
                        stopAuto(); startAuto();
                        return;
                    }
                }
            }, { passive:false });
        }

        // helper
        function isMobileDevice(){
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }

        // Init first state
        showSlide(currentIndex);
        startAuto();

        // While auto-rotating, add the same smooth feedback
        // Replace setInterval callback to include bumpScale when sliding
        // Note: Keep same timing and behavior
        clearInterval(autoSlideInterval);
        autoSlideInterval = setInterval(function(){
            if (mainSwiper.activeIndex === 3) {
                currentIndex = (currentIndex + 1) % $slides.length;
                bumpScale();
                showSlide(currentIndex);
            }
        }, 3000);
    }

    function schedule(){ if (++tries > maxTries) return; raf(tryInit); }
    tryInit();
})();
